/**
 * Cabeçalho:
 * - marca a classe "is-scrolled" ao rolar, para virar uma barra flutuante arredondada;
 * - na página de produto, marca "is-docked" quando o menu de âncoras (sticky, logo abaixo
 *   do cabeçalho) encosta nele: aí o cabeçalho volta ao estilo padrão (reto) para os dois
 *   encaixarem sem vão, como no site da Renova Be;
 * - com "Esconder ao rolar para baixo" (header--reveal), marca "is-hidden" enquanto a pessoa
 *   desce a página e tira assim que ela rola para cima;
 * - expõe a altura real do cabeçalho em --header-height, usada pelo menu de âncoras
 *   (section-tabs.js) para saber onde grudar.
 */
(() => {
  const initHeader = () => {
  const header = document.querySelector('[data-header]');
  if (!header || header.dataset.initialized) return;
  header.dataset.initialized = 'true';

  const inner = header.querySelector('.header__inner') || header;
  const tabs = document.querySelector('[data-section-tabs]');
  const sticky = header.classList.contains('header--sticky');
  const reveal = sticky && header.classList.contains('header--reveal');
  const wrapper = header.closest('.shopify-section') || header;
  let lastScrollY = window.scrollY;

  // Só faz sentido medir a posição do cabeçalho enquanto ele é fixo (fica na tela ao rolar).
  // Sem isso, ele some por trás do topo e o menu de âncoras deve grudar em 0, não num valor negativo.
  // Só reescreve a variável quando o valor muda: ela fica no <html>, e cada escrita obriga o
  // navegador a recalcular o estilo da página inteira (antes acontecia a cada quadro de rolagem).
  let lastHeight = -1;
  const setHeaderHeight = () => {
    const height = sticky ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
    if (height === lastHeight) return;
    lastHeight = height;
    document.documentElement.style.setProperty('--header-height', `${height}px`);
  };

  // Base da comparação para o encaixe: a borda de baixo do cabeçalho, "congelada" no instante em
  // que ele encaixa. Enquanto NÃO está encaixado, acompanha o valor ao vivo (pílula ou padrão,
  // tanto faz) — é isso que o menu de âncoras precisa tocar. Se continuasse acompanhando o valor
  // ao vivo depois de encaixado, o próprio encaixe (que encolhe o cabeçalho) desfaria a condição
  // que o causou, e ele ficaria piscando entre os dois estilos a cada pixel rolado.
  let dockThreshold = header.getBoundingClientRect().bottom;

  // Leituras de posição primeiro, escritas (classes) depois: misturar as duas força o navegador
  // a recalcular o layout no meio do quadro, várias vezes por rolagem.
  const updateState = () => {
    const y = window.scrollY;
    const wasDocked = header.classList.contains('is-docked');
    if (!wasDocked) dockThreshold = header.getBoundingClientRect().bottom;
    const tabsTop = tabs ? tabs.getBoundingClientRect().top : 0;

    header.classList.toggle('is-scrolled', y > 24);

    if (reveal) {
      const yPos = Math.max(0, y);
      const delta = yPos - lastScrollY;
      // Ignora tremidinhas (rolagem elástica do iOS, trackpad) para não piscar
      if (Math.abs(delta) > 6) {
        // Não esconde com menu/busca aberto nem enquanto ainda está no topo da página
        const menuOpen = header.querySelector('details[open], [aria-expanded="true"]');
        const hide = delta > 0 && yPos > wrapper.offsetHeight && !menuOpen;
        header.classList.toggle('is-hidden', hide);
        lastScrollY = yPos;
      }
      if (yPos <= 0) header.classList.remove('is-hidden');
    }

    if (tabs) {
      header.classList.toggle('is-docked', tabsTop <= dockThreshold + 1);
    }
  };

  // Igual ao menu de âncoras: agrupa num único quadro de animação por vez, para não repetir a
  // mesma leitura de posição a cada disparo do evento de rolagem (que pode ser dezenas por
  // segundo) — sem isso, a rolagem rápida trava.
  let scrollTicking = false;
  const onScroll = () => {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(() => {
      updateState();
      setHeaderHeight();
      scrollTicking = false;
    });
  };

  // Enquanto o cabeçalho está em transição (virando pílula ou voltando ao padrão), a altura
  // muda a cada quadro: acompanha de perto para o menu de âncoras não saltar nem sobrepor.
  let raf = null;
  const trackDuringTransition = () => {
    setHeaderHeight();
    raf = requestAnimationFrame(trackDuringTransition);
  };
  const startTracking = () => {
    if (raf === null) raf = requestAnimationFrame(trackDuringTransition);
  };
  const stopTracking = () => {
    if (raf !== null) cancelAnimationFrame(raf);
    raf = null;
    setHeaderHeight();
  };

  inner.addEventListener('transitionrun', startTracking);
  inner.addEventListener('transitionend', stopTracking);
  inner.addEventListener('transitioncancel', stopTracking);
  // O esconder/mostrar anima o wrapper da section: o menu de âncoras acompanha a subida/descida
  if (reveal && wrapper !== header) {
    wrapper.addEventListener('transitionrun', startTracking);
    wrapper.addEventListener('transitionend', stopTracking);
    wrapper.addEventListener('transitioncancel', stopTracking);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  updateState();
  setHeaderHeight();
  };

  initHeader();
  // Editor de temas: o cabeçalho redesenhado precisa dos eventos de novo
  document.addEventListener('shopify:section:load', initHeader);
})();
